import comp from "./MetaTags";
export default comp;
